import { render, staticRenderFns } from "./lottostatus.vue?vue&type=template&id=362ca5ae&scoped=true&"
import script from "./lottostatus.vue?vue&type=script&lang=js&"
export * from "./lottostatus.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "362ca5ae",
  null
  
)

export default component.exports